import type React from 'react';

interface PageIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function PageIcon({ size = 24, ...props }: PageIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_17071_188498)">
        <mask
          id="mask0_17071_188498"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="16"
        >
          <path
            d="M7.23077 0H1.08462C0.488077 0 0 0.490909 0 1.09091V14.9091C0 15.5091 0.488077 16 1.08462 16H10.4846C11.0812 16 11.5692 15.5091 11.5692 14.9091V4.36364L7.23077 0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_17071_188498)">
          <path
            d="M7.23077 0H1.08462C0.488077 0 0 0.490909 0 1.09091V14.9091C0 15.5091 0.488077 16 1.08462 16H10.4846C11.0812 16 11.5692 15.5091 11.5692 14.9091V4.36364L9.03846 2.54545L7.23077 0Z"
            fill="#4285F4"
          />
        </g>
        <mask
          id="mask1_17071_188498"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="16"
        >
          <path
            d="M7.23077 0H1.08462C0.488077 0 0 0.490909 0 1.09091V14.9091C0 15.5091 0.488077 16 1.08462 16H10.4846C11.0812 16 11.5692 15.5091 11.5692 14.9091V4.36364L7.23077 0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_17071_188498)">
          <path
            d="M7.54803 4.04456L11.5692 8.08819V4.36365L7.54803 4.04456Z"
            fill="url(#paint0_linear_17071_188498)"
          />
        </g>
        <mask
          id="mask2_17071_188498"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="16"
        >
          <path
            d="M7.23077 0H1.08462C0.488077 0 0 0.490909 0 1.09091V14.9091C0 15.5091 0.488077 16 1.08462 16H10.4846C11.0812 16 11.5692 15.5091 11.5692 14.9091V4.36364L7.23077 0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_17071_188498)">
          <path
            d="M2.89233 11.6364H8.67695V10.9091H2.89233V11.6364ZM2.89233 13.0909H7.2308V12.3636H2.89233V13.0909ZM2.89233 8V8.72727H8.67695V8H2.89233ZM2.89233 10.1818H8.67695V9.45455H2.89233V10.1818Z"
            fill="#F1F1F1"
          />
        </g>
        <mask
          id="mask3_17071_188498"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="16"
        >
          <path
            d="M7.23077 0H1.08462C0.488077 0 0 0.490909 0 1.09091V14.9091C0 15.5091 0.488077 16 1.08462 16H10.4846C11.0812 16 11.5692 15.5091 11.5692 14.9091V4.36364L7.23077 0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_17071_188498)">
          <path
            d="M7.23077 0V3.27273C7.23077 3.87545 7.71614 4.36364 8.31539 4.36364H11.5692L7.23077 0Z"
            fill="#A1C2FA"
          />
        </g>
        <mask
          id="mask4_17071_188498"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="16"
        >
          <path
            d="M7.23077 0H1.08462C0.488077 0 0 0.490909 0 1.09091V14.9091C0 15.5091 0.488077 16 1.08462 16H10.4846C11.0812 16 11.5692 15.5091 11.5692 14.9091V4.36364L7.23077 0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask4_17071_188498)">
          <path
            d="M1.08462 0C0.488077 0 0 0.490909 0 1.09091V1.18182C0 0.581818 0.488077 0.0909091 1.08462 0.0909091H7.23077V0H1.08462Z"
            fill="white"
            fillOpacity="0.2"
          />
        </g>
        <mask
          id="mask5_17071_188498"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="16"
        >
          <path
            d="M7.23077 0H1.08462C0.488077 0 0 0.490909 0 1.09091V14.9091C0 15.5091 0.488077 16 1.08462 16H10.4846C11.0812 16 11.5692 15.5091 11.5692 14.9091V4.36364L7.23077 0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask5_17071_188498)">
          <path
            d="M10.4846 15.9091H1.08462C0.488077 15.9091 0 15.4182 0 14.8182V14.9091C0 15.5091 0.488077 16.0001 1.08462 16.0001H10.4846C11.0812 16.0001 11.5692 15.5091 11.5692 14.9091V14.8182C11.5692 15.4182 11.0812 15.9091 10.4846 15.9091Z"
            fill="#1A237E"
            fillOpacity="0.2"
          />
        </g>
        <mask
          id="mask6_17071_188498"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="16"
        >
          <path
            d="M7.23077 0H1.08462C0.488077 0 0 0.490909 0 1.09091V14.9091C0 15.5091 0.488077 16 1.08462 16H10.4846C11.0812 16 11.5692 15.5091 11.5692 14.9091V4.36364L7.23077 0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask6_17071_188498)">
          <path
            d="M8.31539 4.36361C7.71614 4.36361 7.23077 3.87543 7.23077 3.27271V3.36361C7.23077 3.96634 7.71614 4.45452 8.31539 4.45452H11.5692V4.36361H8.31539Z"
            fill="#1A237E"
            fillOpacity="0.1"
          />
        </g>
        <path
          d="M7.23077 0H1.08462C0.488077 0 0 0.490909 0 1.09091V14.9091C0 15.5091 0.488077 16 1.08462 16H10.4846C11.0812 16 11.5692 15.5091 11.5692 14.9091V4.36364L7.23077 0Z"
          fill="url(#paint1_radial_17071_188498)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_17071_188498"
          x1="208.63"
          y1="38.7636"
          x2="208.63"
          y2="408.465"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A237E" stopOpacity="0.2" />
          <stop offset="1" stopColor="#1A237E" stopOpacity="0.02" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_17071_188498"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(36.6519 31.4406) scale(1865.52 1865.52)"
        >
          <stop stopColor="white" stopOpacity="0.1" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_17071_188498">
          <rect width="11.5692" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
